import axiosRequest from "api";
import { payloadHelper } from "helpers/payload-helper";

import { PromotionListResType } from "./type";

export const promotionApi = {
  async getPromotionList() {
    const response = await axiosRequest.post<PromotionListResType>(
      "",
      payloadHelper("PromotionList", null, null)
    );
    return response.data;
  },
};
